import React from 'react';

import Contact from "./contact";
import { Link } from "react-router-dom";

const FinOpe = () => {

  return (
    <>
    </>
  );
}
export default FinOpe;
